import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { STORAGE } from "@/shared/utils/storage";

export type Section = "landing" | "designer" | "operator" | "control-center";
export type ThemeMode = "light" | "dark" | "system";

const systemDarkQuery = window.matchMedia("(prefers-color-scheme: dark)");

const themeMode = ref<ThemeMode>(STORAGE.themeMode.read());
const systemIsDark = ref<boolean>(systemDarkQuery.matches);

function onSystemChange(e: MediaQueryListEvent) {
	systemIsDark.value = e.matches;
}
systemDarkQuery.addEventListener("change", onSystemChange);

const isDark = computed(() => {
	if (themeMode.value === "system") return systemIsDark.value;
	return themeMode.value === "dark";
});

export function useAppTheme() {
	const route = useRoute();

	const section = computed<Section>(() => {
		return (route.meta.section as Section) || "landing";
	});

	function setThemeMode(mode: ThemeMode) {
		themeMode.value = mode;
		STORAGE.themeMode.write(mode);
	}

	return {
		section,
		isDark,
		themeMode,
		setThemeMode,
	};
}
